import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import InternetLobbySingleProductBlockData from 'app/Models/Content/InternetLobbySingleProductBlockData';
import React from 'react';
import {getImageProps} from 'app/utilities/ImageProps';
import {Container, Col} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import useFadeIn from 'app/Components/Shared/UseFadeIn';

const InternetLobbySingleProductBlock = ({data, context}: ComponentProps<InternetLobbySingleProductBlockData>) => {
  const {fadeClass, ref} = useFadeIn();

  return (
    <Container>
      <a ref={ref} href={data.buttonLink.value} className={`InternetLobbySingleProductBlock ${fadeClass}`}>
        <div className='InternetLobbySingleProductBlock__title-subtitle-button'>
          <h2> {data.title?.value}</h2>

          <span className='InternetLobbySingleProductBlock__title-subtitle-button__subtitle'>{data.subtitle?.value}</span>

          <div className='InternetLobbySingleProductBlock__title-subtitle-button__button'>{data.buttonLinkTitle?.value}</div>
        </div>

        <Image {...getImageProps(isMobile ? data.mobileImage : data.image, context)} />
      </a>
    </Container>
  );
};

export default InternetLobbySingleProductBlock;
